import Sortable from "sortablejs"
import { updatePositions, setUpCollapsibleForm } from "../../../util/methods"

$(document).on("turbolinks:load", function () {
  var $faqContainer = $("#js-sortable-faqs")

  if ($faqContainer.length) {
    new Sortable($faqContainer[0], {
      draggable: ".js-faq-nested-field",
      handle: ".draggable-handle",
      onSort: function () {
        updatePositions($(".js-faq-nested-field"))
      },
    })

    $faqContainer
      .on("cocoon:after-insert", function (e, $insertedItem) {
        if ($insertedItem.hasClass("js-faq-nested-field")) {
          setUpCollapsibleForm($insertedItem)
          updatePositions($(".js-faq-nested-field"))
        }
      })
      .on("cocoon:after-remove", function (e, $removedItem) {
        if ($removedItem.hasClass("js-faq-nested-field")) {
          updatePositions($(".js-faq-nested-field"))
        }
      })
  }
})
